import React, { ErrorInfo, ReactNode } from 'react'
import Router from 'next/router'
import { Button } from '@arco-design/web-react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
  errorInfo: ErrorInfo | null
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error, errorInfo })
    // 你可以将错误日志记录到外部服务
    console.error('ErrorBoundary caught an error', error, errorInfo)
    // 将错误信息传递给自定义错误页面
    Router.push({
      pathname: '/_error',
      query: { error: error.toString(), errorInfo: errorInfo.componentStack }
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <Button
          onClick={() => {
            Router.push({
              pathname: '/board'
            })
          }}
        >
          Go to Dashboard
        </Button>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
